import { useQuery } from "@tanstack/react-query";
import { businessCardApi } from "../../../../../services/company-office/BusinessCard.service";
import { useMemo } from "react";
import { useRequests } from "../../../../../hook";

const highPriorityUsers = [
  "botit@viags.vn",
  "huongptt@viags.vn",
  "hieptd@viags.vn",
  "anhttt@viags.vn",
  "thiennv@viags.vn",
  "huongdtt@viags.vn",
];

export const useBCRequests = () => {
  const { getMyRequests, getRequests } = useRequests();

  const query = useQuery<any>({
    queryKey: ["BC-requests"],
    queryFn: () => businessCardApi.getRequests(),
    select: (response: { value: any[] }) => {
      const mappedRequests = response.value.map(businessCardApi.toResponse);
      return mappedRequests.reverse();
    },
  });

  const requests = useMemo(
    () => getRequests(query?.data, highPriorityUsers),
    [getRequests, query?.data]
  );

  const myRequests = useMemo(
    () => getMyRequests(query?.data),
    [getMyRequests, query?.data]
  );

  return { ...query, requests, myRequests };
};
